<template>

    <title-card title="Panelists to recontact" side-icon="mdi-clipboard-text-outline"
                help="edit-project-recontact-list">

        <v-alert dense type="info" class="body-2">Paste panelist identifiers into the box below (Max 1000)</v-alert>

        <identifiers-paste-box
                               @error="emitError"
                               @change="emitIdentifiers"
        ></identifiers-paste-box>

    </title-card>

</template>

<script>

import TitleCard from "../../../../../components/UI/TitleCard";
import Json from 'vue-json-pretty';
import IdentifiersPasteBox from "../../../../../components/UI/IdentifiersPasteBox";

export default {

    components: {
        Json,
        TitleCard,
        IdentifiersPasteBox
    },

    methods: {

        emitError(error) {
            this.$emit('error', {name: 'tab8', error: true});
        },

        emitIdentifiers(data) {
            this.$emit('error', {name: 'tab8', error: false});
            this.$emit('change', {recontact_identifiers: data});
        },
    }
}
</script>